export function isChronoValide(value: string): boolean {
    return /^[0-9]{2,3}:[0-5][0-9]$/.test(value);
}